import { BASE_URL } from "../constants/constants";
import AuthUtils from "../auth/AuthUtils";
export class ActionedService {
  public async addActionedInspection(actioned: any) {
    try {
      let response = await fetch(`${BASE_URL}/actions/add`, {
        method: "POST",
        headers: AuthUtils.getHeaders(),
        body: JSON.stringify(actioned),
        credentials: "include"
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e: any) {
      return {
        error: e.message,
        status: 500,
        ok: false,
      };
    }
  }
  public async deleteAllActionedInspection(
    companyId: String,
    employeeId: String
  ) {
    try {
      let response = await fetch(
        `${BASE_URL}/actions/all/employees/${employeeId}/companies/${companyId}`,
        {
          method: "DELETE",
          headers: AuthUtils.getHeaders(),
          credentials: "include"
        }
      );
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false,
      };
    }
  }
  public async deleteActionedInspection(companyId: String, actionedId: String) {
    try {
      let response = await fetch(
        `${BASE_URL}/actions/${actionedId}/companies/${companyId}`,
        {
          method: "DELETE",
          headers: AuthUtils.getHeaders(),
          credentials: "include"
        }
      );
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false,
      };
    }
  }
  public async updateActionedInspection(actioned: any) {
    try {
      let response = await fetch(`${BASE_URL}/actions/${actioned._id}`, {
        method: "POST",
        headers: AuthUtils.getHeaders(),
        body: JSON.stringify(actioned),
        credentials: "include"
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false,
      };
    }
  }
  public async deleteCompletedInspection(actioned: any) {
    try {
      let response = await fetch(`${BASE_URL}/actions/${actioned._id}`, {
        method: "DELETE",
        headers: AuthUtils.getHeaders(),
        body: JSON.stringify(actioned),
        credentials: "include"
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false,
      };
    }
  }
  public async deleteAllSelectedCompletedInspection(selectedList: any) {
    try {
      let response = await fetch(`${BASE_URL}/actions/delete/multiple`, {
        method: "DELETE",
        headers: AuthUtils.getHeaders(),
        body: JSON.stringify(selectedList),
        credentials: "include"
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false,
      };
    }
  }
  public async getCompletedByCompanyId(companyId: String) {
    try {
      let response = await fetch(
        `${BASE_URL}/actions/completed/companies/${companyId}`,
        {
          method: "GET",
          headers: AuthUtils.getHeaders(),
          credentials: "include"
        }
      );
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false,
      };
    }
  }

  public async getActionedById(actionedId: String) {
    try {
      let response = await fetch(`${BASE_URL}/actions/${actionedId}`, {
        method: "GET",
        headers: AuthUtils.getHeaders(),
        credentials: "include"
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false,
      };
    }
  }

  public async importInspections(companyId: String, data: any) {
    var encodedString = btoa(unescape(encodeURIComponent(data)));
    try {
      let response = await fetch(
        `${BASE_URL}/actions/import/companies/${companyId}`,
        {
          method: "POST",
          headers: AuthUtils.getHeaders(),
          body: JSON.stringify({ file: encodedString }),
          credentials: "include"
        }
      );
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false,
      };
    }
  }
}
